<template>
  <b-row class="info-row">
    <b-col class="entry-label" :sm="sizing" >
      <span class="entry-label-text" v-b-tooltip :title="tip">
        {{ title }}
      </span>
    </b-col>
    <b-col class="entry-info" :sm="12 - sizing">
      <slot></slot>
    </b-col>
  </b-row>
  
</template>

<script>
export default {
  props: {
    'title': String,
    'tip': String,
    'sizing': {
      type: Number,
      default: 4
    }
  }
};
</script>

<style lang="scss">
@import '@/style/_variables.scss';

.info-row {
  padding: 8px 0px;
  min-height: 45px;
}

.entry-label {
  text-align: left;
  color: $blue;
  position: relative;
  height: 15px;
}

.entry-label-text {
  position: absolute;
  left: 8px;
  top: 20%;
}

.entry-info {
  position: relative;
  text-align: left;
  height: auto;
  line-height: 38px;
}
</style>
